module.exports = __webpack_public_path__ + "assets/img/home_banner2_bg.986ecab2.png";